/**
 * Available colors to choose on color picker
 */
const COLORS = [
  "#00FFFF",
  "#3FE0D0",
  "#0080FF",
  "#0F52BA",
  "#000080",
  "#111E6C",
  "#1D2951",
  "#003152",
  "#152238",
  "#1C2E4A",
  "#03002E",
  "#010048",
  "#FF0000",
  "#FF0800",
  "#FF2400",
  "#FF2800",
  "#C21807",
  "#B80F0A",
  "#960018",
  "#7C0A02",
  "#800000",
  "#420D09",
  "#1C0000",
  "#0E0000",
];

export default COLORS;
